export interface MapGeometry {
  minLat: number;
  maxLat: number;
  minLong: number;
  maxLong: number;
}
